// Shared pricing rules for the Shop & checkout.

export const PACK_DISCOUNTS = {
  4: 0.10,
  8: 0.15,
  12: 0.25,
};

export const PACK_SIZES = [4, 8, 12];

export const SHIPPING_FEE = 8.90;
export const SHIPPING_LABEL = "Flat-rate shipping · NZ-wide";

export const round2 = (n) => Math.round(n * 100) / 100;

export const calcPackBase = (size, unitPrice) => round2(size * unitPrice);
export const calcPackPrice = (size, unitPrice) =>
  round2(size * unitPrice * (1 - (PACK_DISCOUNTS[size] || 0)));
export const calcPackSavings = (size, unitPrice) =>
  round2(calcPackBase(size, unitPrice) - calcPackPrice(size, unitPrice));
